<script setup lang="ts">
import { useQuizStore } from "../../../stores";

import EmbedQuiz from "./EmbedQuiz/EmbedQuiz.vue";
import IclassQuiz from "./IclassQuiz/IclassQuiz.vue";
import Fullscreen from '../../General/Fullscreen.vue';
import Iframe from '../../General/Iframe.vue';

const quizStore = useQuizStore()
</script>

<template>
    <template v-if="quizStore.quiz.scormUrl">
        <Fullscreen class="p-3 h-full">
            <Iframe :src="quizStore.quiz.scormUrl" orientation="full"></Iframe>
        </Fullscreen>
    </template>
    <template v-else>
        <EmbedQuiz v-if="quizStore.quiz.id <= 0"></EmbedQuiz>
        <IclassQuiz v-else></IclassQuiz>
    </template>
</template>